import { idb } from "../db/index.ts";
import { g } from "../util/index.ts";
import addFirstNameShort from "../util/addFirstNameShort.ts";

// M3-1: the standalone injuries page was retired in favour of an injuries
// MobileSheet mounted on the roster (team) tab. The sheet only needs ONE team's
// CURRENT injuries (name + type + games remaining), so this focused query
// replaces the old league-wide/other-team/season-archive view pipeline the page
// carried (that browsing surface was a thin audit-era addition, dropped by
// product decision). Fetched ad hoc via the `getInjuriesSheet` worker RPC.
//
// The return shape is intentionally an anonymous structural type (no exported
// alias) so the RPC codegen (tools/genApiTypes.ts) expands it inline in
// common/types/.gen/workerApi.d.ts rather than emitting an unresolved name.
export const getInjuriesSheet = async (tid: number) => {
	const playersAll = await idb.cache.players.indexGetAll("playersByTid", tid);

	const players = await idb.getCopies.playersPlus(playersAll, {
		attrs: ["pid", "firstName", "lastName", "injury"],
		ratings: ["pos"],
		season: g.get("season"),
		showNoStats: true,
		showRookies: true,
		fuzz: true,
	});

	const injuries: {
		pid: number;
		firstName: string;
		lastName: string;
		pos: string;
		type: string;
		games: number;
	}[] = [];
	for (const p of players) {
		if (p.injury.gamesRemaining > 0) {
			injuries.push({
				pid: p.pid,
				firstName: p.firstName,
				lastName: p.lastName,
				pos: p.ratings.pos,
				type: p.injury.type,
				games: p.injury.gamesRemaining,
			});
		}
	}

	// Longest absence first — the biggest rotation problems read at the top.
	injuries.sort((a, b) => b.games - a.games);

	return {
		injuries: addFirstNameShort(injuries),
	};
};
